import React from 'react'

function CurrencyIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#707070"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M0 0H72V72H0z"
            data-name="Rectangle 8940"
            transform="translate(1394 288)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 436" transform="translate(-1394 -288)">
        <g data-name="Group 56491" transform="translate(1400.519 296.652)">
          <g stroke="#263238" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1">
            <path
              fill="#d3dade"
              d="M0 0H26.719V46.261H0z"
              data-name="Rectangle 8936"
              transform="rotate(-48.78 26.7 12.107)"
            ></path>
            <path
              fill="#fff"
              d="M20.877 10.423a3.224 3.224 0 01-4.549.3 3.623 3.623 0 01-.283-.273L5.935 21.985a3.119 3.119 0 01.317.232 3.222 3.222 0 01.3 4.549c-.044.049-.09.095-.139.141l24.859 21.786a1.86 1.86 0 01.123-.155 3.224 3.224 0 014.549-.3 3.613 3.613 0 01.283.283l10.112-11.537a3.147 3.147 0 01-.32-.232 3.222 3.222 0 01-.3-4.549 3.569 3.569 0 01.283-.28L21.12 10.103a3.133 3.133 0 01-.243.32zm9.3 22.467a5.283 5.283 0 11-.491-7.456 5.283 5.283 0 01.491 7.456z"
              data-name="Path 68743"
            ></path>
            <path
              fill="#d3dade"
              d="M0 0H26.719V46.261H0z"
              data-name="Rectangle 8937"
              transform="rotate(-39.74 27.93 3.707)"
            ></path>
            <path
              fill="#fff"
              d="M26.862 8.363a3.222 3.222 0 01-4.54-.417 3.48 3.48 0 01-.232-.324l-11.795 9.811a3.64 3.64 0 01.276.29 3.224 3.224 0 01-.408 4.537c-.053.042-.107.079-.16.118l21.135 25.413c.049-.044.095-.09.146-.134a3.224 3.224 0 014.54.417 3.471 3.471 0 01.232.324l11.8-9.809a2.968 2.968 0 01-.276-.29 3.222 3.222 0 01.417-4.54 3.109 3.109 0 01.324-.232L27.152 8.085a2.97 2.97 0 01-.29.278zm5.663 23.648a5.283 5.283 0 11.683-7.435 5.283 5.283 0 01-.683 7.435z"
              data-name="Path 68744"
            ></path>
            <path
              fill="#d3dade"
              d="M0 0H26.719V46.261H0z"
              data-name="Rectangle 8938"
              transform="rotate(-25.92 31.316 -19.967)"
            ></path>
            <path
              fill="#fff"
              d="M36.47 7.087a3.224 3.224 0 01-4.3-1.489 3.531 3.531 0 01-.148-.371l-13.807 6.705a3.355 3.355 0 01.2.345 3.224 3.224 0 01-1.489 4.308c-.063.03-.123.053-.185.079l14.448 29.73c.058-.035.114-.067.174-.1a3.222 3.222 0 014.308 1.492 3.323 3.323 0 01.151.368l13.8-6.705a3.365 3.365 0 01-.2-.345 3.226 3.226 0 011.492-4.308 2.965 2.965 0 01.371-.151L36.817 6.888a3.383 3.383 0 01-.347.199zm-.155 24.32a5.283 5.283 0 112.444-7.062 5.283 5.283 0 01-2.444 7.062z"
              data-name="Path 68745"
            ></path>
            <path
              fill="#d3dade"
              d="M0 0H26.719V46.261H0z"
              data-name="Rectangle 8939"
              transform="rotate(-8.7 50.36 -151.874)"
            ></path>
            <path
              fill="#fff"
              d="M48.402 8.757a3.222 3.222 0 01-3.673-2.7 3.356 3.356 0 01-.035-.4L29.533 7.976a3.407 3.407 0 01.09.387 3.224 3.224 0 01-2.7 3.673 1.89 1.89 0 00-.2.021l5 32.674c.065-.016.13-.03.2-.042a3.224 3.224 0 013.673 2.7 2.922 2.922 0 01.032.4l15.166-2.316a3.1 3.1 0 01-.088-.391 3.224 3.224 0 012.7-3.673 3.344 3.344 0 01.4-.035l-5.008-32.7a2.972 2.972 0 01-.396.083zM41.055 31.93a5.283 5.283 0 114.424-6.022 5.283 5.283 0 01-4.424 6.022z"
              data-name="Path 68746"
            ></path>
          </g>
          <text
            fill="#263238"
            data-name="$"
            fontFamily="SegoeUI-Bold, Segoe UI"
            fontSize="5"
            fontWeight="700"
            transform="matrix(.985 -.174 .174 .985 38.976 29.18)"
          >
            <tspan x="0" y="0">
              $
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  )
}

export default CurrencyIcon
